import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import PdfForm from '../PdfForm'
import ShareFrom from '../ShareForm'
import Disclaimer from '../Disclaimer'
import TransomConfigurator from './../TransomConfigurator'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView09ImageOptions } from './views/ExteriorView09'

class Xr41Summary extends Component {
  constructor (props) {
    super(props)

    this.state = {
      expanded: false,
      overlayUrls: []
    }

    this.handleOverlayUrls = this.handleOverlayUrls.bind(this)
  }

  handleOverlayUrls (urls) {
    const current = this.state.overlayUrls
    if (urls.length !== current.length || urls.some((u, i) => u !== current[i])) {
      this.setState({ overlayUrls: urls })
    }
  }

	render() {
		let imageOptions = exteriorView09ImageOptions

    let image = (
      <div style={{ position: 'relative' }}>
        <TransomConfigurator
          colorMultiplier={0.65}
          name={this.props.configuration.transom.Name}
          port={this.props.configuration.transom.Port}
          transomSize={{ width: 2110, height: 610 }}
          transform={[
            0.11698, 0.015833, 0, 4.3e-5, 0.057552, 0.15186, 0, 7.0e-5, 0, 0, 1,
            0, 720.886967, 373.536243, 0, 1
          ]}
        >
          <ConfiguratorImage
            boat='Xr41'
            configuration={this.props.configuration.exterior}
            options={imageOptions}
            onOverlayUrls={this.handleOverlayUrls}
          />
        </TransomConfigurator>
        {this.state.overlayUrls.length > 0 && (
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', pointerEvents: 'none', zIndex: 10 }}>
            {this.state.overlayUrls.map((url) => (
              <img key={url} src={url} alt="" style={{ position: 'absolute', top: 0, left: 0, width: '100%', objectFit: 'contain' }} />
            ))}
          </div>
        )}
      </div>
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption style={{ position: 'relative' }}>
          <h1>
            <Trans defaults='Summary' />
          </h1>
          <h2>
            <Trans defaults='Congratulations!' />
          </h2>
          <p>
            <Trans defaults='You have now configured the basics of an XR 41. If you want a full configuration of your boat, please contact your local X-Yachts Dealer.' />
          </p>

          <PdfForm
            boat='xr41'
            country={this.props.country}
            countries={this.props.countries}
            configuration={this.props.configuration}
            code={this.props.code}
          />

          <ShareFrom
            configuration={this.props.configuration}
            boat='xr41'
            code={this.props.code}
          />

          <Disclaimer />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(Xr41Summary)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41Summary.js